<template>
  <div class="sign-page">
    <div class="tip">正在跳转...</div>
  </div>
</template>

<script>
export default {
  name: 'SignPage',
  created() {
    this.$store.commit('changeTitleShow', false)
    this.redirectToSign()
  },
  methods: {
    redirectToSign() {
      const { param, domain, suffix } = this.$route.query
      if (param && domain && suffix) {
        window.location.replace(`https://${domain}.${suffix}/${param}`)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.sign-page {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 99999;
  background: #fff;
  iframe {
    width: 100%;
    height: 100%;
    border: none;
  }
  .tip {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    font-size: 1.25rem;
    color: #999;
  }
}
</style>